/* eslint-disable react-hooks/rules-of-hooks */
import { Link } from 'react-router-dom';
import { useState } from 'react';

const index = () => {
	const [nav, setNav] = useState(false);

	const changeBackground = () => {
		if (window.scrollY >= 80) {
			setNav(true);
		} else {
			setNav(false);
		}
	};

	window.addEventListener('scroll', changeBackground);

	const pages = [
		{
			title: 'Home',
			route: '/',
		},
		{
			title: 'Gallery',
			route: '/gallery',
		},
	];
	return (
		<nav
			class={
				nav
					? 'bg-white fixed w-full z-20 top-0 start-0'
					: 'bg-transparent fixed w-full z-20 top-0 start-0'
			}
		>
			<div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
				<Link
					to="/"
					class="flex tracking-widest items-center space-x-3 rtl:space-x-reverse"
				>
					<span
						class={
							nav
								? 'logo self-center text-4xl text-gray-800 font-semibold whitespace-nowrap '
								: 'logo self-center text-4xl font-semibold text-white whitespace-nowrap '
						}
					>
						ExploreHub
					</span>
				</Link>
				<div class="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
					<button
						type="button"
						class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
					>
						Get started
					</button>
					<button
						data-collapse-toggle="navbar-sticky"
						type="button"
						class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
						aria-controls="navbar-sticky"
						aria-expanded="false"
					>
						<span class="sr-only">Open main menu</span>
						<svg
							class="w-5 h-5"
							aria-hidden="true"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 17 14"
						>
							<path
								stroke="currentColor"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M1 1h15M1 7h15M1 13h15"
							/>
						</svg>
					</button>
				</div>
				<div
					class="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
					id="navbar-sticky"
				>
					<ul class="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg  md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 ">
						{pages.map((page) => (
							<li>
								<Link
									to={page.route}
									class={
										nav
											? 'block py-2 px-3 text-gray-800 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500'
											: 'block py-2 px-3 text-gray-300 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 '
									}
									aria-current="page"
								>
									{page.title}
								</Link>
							</li>
						))}
					</ul>
				</div>
			</div>
		</nav>
	);
};

export default index;
